import { cn } from '@/lib/utils';
import { forwardRef } from 'react';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
}

const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = 'md', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'animate-spin rounded-full border-grayscale-100 border-t-grayscale-600',
          {
            'size-4 border-2': size === 'sm',
            'size-6 border-2': size === 'md',
            'size-12 border-4': size === 'lg',
          },
          className
        )}
        {...props}
      />
    );
  }
);

Spinner.displayName = 'Spinner';

export { Spinner };
